import { BrandsCatalog } from "./types";
import catalog from "./brandsCatalog.json";

/**
 * Per-brand presentation, bundled into the app. Inherently public — the browser must
 * download the active brand's assets to render — so it is co-located with the asset
 * files it references under /adminportal/branding/. The host -> brand mapping lives
 * server-side and is intentionally absent here.
 */
const brandsCatalog = catalog as unknown as BrandsCatalog;

/** Brand used before resolution completes and whenever the API is unreachable. */
export const DEFAULT_BRAND_KEY = "default";

export default brandsCatalog;
